import React from "react";
import { NotificationsContext } from "./notifications-context";
import { useNotificationsHook } from "./notifications-hooks";

export function ContextNotificationsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const value = useNotificationsHook();

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}
